import Vue from 'vue';
import Vuex from 'vuex';

// FIXME: As it turns out most of our store modules are simple CRUD modules in which we have 90% repetition, whe should
// refactor that to one default store factory.
// We want to put complex states (e.g. that of the image 3d viewer or the product edit page) each into one dedicated
// store that is important in the respective components.
// Then there is something like a global state such as the running tasks which we would import into the component
// that shows the currently running tasks and those that create synchronous tasks requiring feedback upon completion.

// import the auto exporter
import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...modules,
  },
});
